import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomClassroomIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 48 48" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42 7H16C15.448 7 15 7.448 15 8V30C15 30.552 15.448 31 16 31H42C42.552 31 43 30.552 43 30V8C43 7.448 42.552 7 42 7Z"
        fill={`url(#${uuid}paint0_linear)`}
      />
      <path
        d="M22.5 16C22.329 16 15 16 15 16V21C15 21 22.329 21 22.5 21C23.881 21 25 19.881 25 18.5C25 17.119 23.881 16 22.5 16Z"
        fill="black"
        opacity="0.05"
      />
      <path
        d="M22.5 16.5C22.326 16.5 15 16.5 15 16.5V20.5C15 20.5 22.326 20.5 22.5 20.5C23.605 20.5 24.5 19.605 24.5 18.5C24.5 17.395 23.605 16.5 22.5 16.5Z"
        fill="black"
        opacity="0.07"
      />
      <path
        d="M9 15C6.8 15 5 13.2 5 11C5 8.8 6.8 7 9 7C11.2 7 13 8.8 13 11C13 13.2 11.2 15 9 15Z"
        fill={`url(#${uuid}paint1_linear)`}
      />
      <path
        d="M22.5 17H9C6.791 17 5 18.791 5 21V30C5 30.552 5.448 31 6 31H12C12.552 31 13 30.552 13 30V21C13 20.448 13.448 20 14 20H22.5C23.328 20 24 19.328 24 18.5C24 17.672 23.328 17 22.5 17Z"
        fill={`url(#${uuid}paint2_linear)`}
      />
      <path
        d="M9 41C6.8 41 5 39.2 5 37C5 34.8 6.8 33 9 33C11.2 33 13 34.8 13 37C13 39.2 11.2 41 9 41Z"
        fill={`url(#${uuid}paint3_linear)`}
      />
      <path
        d="M19 41C16.8 41 15 39.2 15 37C15 34.8 16.8 33 19 33C21.2 33 23 34.8 23 37C23 39.2 21.2 41 19 41Z"
        fill={`url(#${uuid}paint4_linear)`}
      />
      <path
        d="M29 41C26.8 41 25 39.2 25 37C25 34.8 26.8 33 29 33C31.2 33 33 34.8 33 37C33 39.2 31.2 41 29 41Z"
        fill={`url(#${uuid}paint5_linear)`}
      />
      <path
        d="M39 41C36.8 41 35 39.2 35 37C35 34.8 36.8 33 39 33C41.2 33 43 34.8 43 37C43 39.2 41.2 41 39 41Z"
        fill={`url(#${uuid}paint6_linear)`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear`}
          x1="15.00"
          x2="43.00"
          y1="19.00"
          y2="19.00"
        >
          <stop stopColor="#9AE6FF" />
          <stop offset="1" stopColor="#70B2FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint1_linear`}
          x1="6.239"
          x2="11.739"
          y1="8.239"
          y2="13.739"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint2_linear`}
          x1="10.87"
          x2="19.368"
          y1="14.922"
          y2="36.645"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint3_linear`}
          x1="6.239"
          x2="11.739"
          y1="34.239"
          y2="39.739"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint4_linear`}
          x1="16.239"
          x2="21.739"
          y1="34.239"
          y2="39.739"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint5_linear`}
          x1="26.239"
          x2="31.739"
          y1="34.239"
          y2="39.739"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint6_linear`}
          x1="36.239"
          x2="41.739"
          y1="34.239"
          y2="39.739"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#7D38D6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
